module.exports = __webpack_public_path__ + "img/cases-brand-herborist-lazyload-121.4600d308.jpg";